// extracted by mini-css-extract-plugin
export default {"inputFile":"ticketpage_inputFile__9+h6J","required":"ticketpage_required__bIyY1","disabled":"ticketpage_disabled__35Tm7"};